import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { Input, Select, Form, Tabs, Button, Table ,Menu,Row,Col,Breadcrumb,Icon,message,Modal,Popconfirm,Tooltip} from 'antd';
import {PropTypes} from 'prop-types';
import $ from '$'
/** PERSONAL */
import API from '@/API/api';
import {getCloseTagTaskMsgAPI} from '@/API';
import { action } from './';
import CreateTask from "./creat_task/view";
import {columnsOrgign} from './columns'
const { Option } = Select;
const FormItem = Form.Item;
const TabPane = Tabs.TabPane;
const confirm = Modal.confirm;




class HitTag extends Component {
    state = {
        task_id:'',
        name:'',
        selectedRowKeys: [],
        page: 1,
        pagesize: 10,
        selectTagUser:'-1',
        checkTagUser:'-1',
        node_knowledge_type:['-10'],
        tag_type:['-1'],
        tagTypeList:[],
		closeTagTaskMsg:''
    }
    static contextTypes = {
        router: PropTypes.object.isRequired
    };
    componentWillMount() {

        this.getTaskList();
        this.getCheckSelectList()
        axios.post(API.QSELECTTNEW_TASK_TAG_TYPE).then((res)=>{//标签种类的枚举
            res = res.data
            if (res.code === 0) {
                this.setState({tagTypeList:res.data});
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });

    }
    getCheckSelectList=()=>{
        if(this.props.user.role_qselect){
            if(this.props.user.role_qselect.showall>0){
                this.props.getCheckList({name:''})//模糊搜索
                this.props.getSelectList({name:''})//模糊搜索
                this.props.getFilterList()
            }
        }else{
            setTimeout(()=>{
                this.getCheckSelectList()
            },1000)
        }

    }
    componentDidUpdate(preProps,preState) {
        if(preProps.stage!==this.props.stage){
            this.getTaskList()
        }
    }
    onRefreshList = () => {
        this.state.selectedRowKeys = [];
        this.state.page = 1;
        this.getTaskList()
    }
    onAdvanceSearch= () => {
        this.getTaskList()
    };
    getTaskList = () => {
        this.state.selectedRowKeys = []
        let tag_type = [...this.state.tag_type]
        let index = tag_type.findIndex(d=>d=='选中多个')//增加选中多个的效果
        if(index!==-1){
            tag_type.splice(index,1)
        }
        let node_knowledge_type = [...this.state.node_knowledge_type]
        let index1 = node_knowledge_type.findIndex(d=>d=='选中多个')//增加选中多个的效果
        if(index1!==-1){
            node_knowledge_type.splice(index1,1)
        }
        const data = {
            task_id:this.state.searchId,
            name:this.state.searchName,
            select_user:this.state.selectTagUser,
            check_user:this.state.checkTagUser,
            node_knowledge_type:node_knowledge_type,
            tag_type:tag_type,
            page: this.state.page,
            pagesize: this.state.pagesize,
            stage:this.props.stage
        }
        this.props.getTaskList(data);
    };
    toSetTag=(record)=>{//打标签
        this.context.router.history.push(`settag/tasksettag/${record.task_id}`);
    }
    toCheckTag=(record)=>{//打标签审核
        this.context.router.history.push(`settag/taskchecktag/${record.task_id}`);
    }
    toLookTag=(record)=>{//打标签查看
        this.context.router.history.push(`settag/tasklooktag/${record.task_id}`);
    }
    changeSpread=(record)=>{//打标签是否泛化
        let  data = {
            task_id:record.task_id,
            is_spread:~~(!~~record.is_spread),
        }
        axios.post(API.QSELECTTNEW_TASK_CHANGE_SPREAD, data).then((res)=>{
            res = res.data;
            if (res.code === 0) {
                message.success("成功！");
                this.getTaskList();
            }else{
                message.error(res.message);
            }
        },()=>{message.error("失败！")})
    }
   
    
    delTask=()=>{
        const ids = this.state.selectedRowKeys;
        const me = this;
        confirm({
            title: '确定删除任务？',
            content: '删除任务后不可恢复，确定删除吗？',
            onOk() {
                return new Promise((resolve, reject) => {
                    axios.post(API.QSELECTTNEW_TASK_DEL, {task_id:ids}).then((res)=>{
                        res = res.data;
                        if (res.code === 0) {
                            message.success("删除成功！");
                            resolve();
                            me.getTaskList();
                        }else{
                            message.error(res.message);
                            reject();
                        }
                    },()=>{message.error("删除失败！")})
                })
            },
            onCancel() {},
        });
    }
    getCloseTagTaskMsg=()=>{
    		const ids = this.state.selectedRowKeys;
    		getCloseTagTaskMsgAPI({task_id:ids}).then(res=>{
    			this.setState({closeTagTaskMsg:res.data},()=>{
    				this.closeTask()
    			})
    		})
    }
    closeTask=()=>{
        const ids = this.state.selectedRowKeys;
        const me = this;
        let {closeTagTaskMsg}=this.state
        confirm({
            title: '确定关闭任务？',
            content: closeTagTaskMsg,
            onOk() {
                return new Promise((resolve, reject) => {
                    axios.post(API.QSELECTTNEW_TASK_END, {task_id:ids}).then((res)=>{
                        res = res.data;
                        if (res.code === 0) {
                            message.success("关闭成功！");
                            resolve();
                            me.getTaskList();
                        }else{
                            message.error(res.message);
                            reject();
                        }
                    },()=>{message.error("关闭失败！")})
                })
            },
            onCancel() {},
        });
    }
    onlineTask=()=>{
        const ids = this.state.selectedRowKeys;
        const me = this;
        confirm({
            title: '确定入库任务？',
            content: '确定入库任务？',
            onOk() {
                return new Promise((resolve, reject) => {
                    axios.post(API.QSELECTTNEW_TASK_ONLINE, {task_id:ids}).then((res)=>{
                        res = res.data;
                        if (res.code === 0) {
                            message.success("入库成功！");
                            resolve();
                            me.getTaskList();
                        }else{
                            message.error(res.message);
                            reject();
                        }
                    },()=>{message.error("关闭失败！")})
                })
            },
            onCancel() {},
        });
    }
    onlineSusuanTask=()=>{
        const ids = this.state.selectedRowKeys;
        const me = this;
        confirm({
            title: '确定上线任务？',
            content: '确定上线任务？',
            onOk() {
                return new Promise((resolve, reject) => {
                    axios.post(API.QSELECTTNEW_TASK_ONLINE_SUSUAN, {task_id:ids}).then((res)=>{
                        res = res.data;
                        if (res.code === 0) {
                            message.success("上线成功！");
                            resolve();
                            me.getTaskList();
                        }else{
                            message.error(res.message);
                            reject();
                        }
                    },()=>{message.error("关闭失败！")})
                })
            },
            onCancel() {},
        });
    }

    onTestTask=()=>{
        const ids = this.state.selectedRowKeys;
        axios.post(API.QSELECTTNEW_TASK_TEST, {task_id:ids}).then((res)=>{
            res = res.data;
            if (res.code === 0) {
                message.success("上测试成功！");
                this.getTaskList();
            }else{
                message.error(res.message);
            }
        },()=>{message.error("上测试失败！")})
    }
    onAssignSelect=()=>{
        const ids = this.state.selectedRowKeys;
        axios.post(API.QSELECTTNEW_TASK_ASSIGN_SELECT_USER, {task_id:ids,user_id:this.state.assignSelect}).then((res)=>{
            res = res.data;
            if (res.code === 0) {
                message.success("分配成功！");
                this.setState({assignSelectVisible:false})
                this.getTaskList();
            }else{
                message.error(res.message);
                this.setState({assignSelectVisible:false})
            }
        },()=>{message.error("分配失败！")})
    }
    //-----------------------------------------------------------------------------------------------------下载模板
    downloadList=()=>{
        const ids = this.state.selectedRowKeys;

        var form = $("<form>");   //定义一个form表单
        form.attr('style', 'display:none');   //在form表单中添加查询参数
        form.attr('target', '');
        form.attr('method', 'post');
        form.attr('action', API.QSELECTTNEW_TASK_DOWNLOAD);
        var input1 = $('<input>');
        input1.attr('type', 'hidden');
        input1.attr('name', 'task_id');
        input1.attr('value',ids);
        $('body').append(form);  //将表单放置在web中
        form.append(input1);   //将查询参数控件提交到表单上
        form.submit();
    }
    onAssignCheck=()=>{
        const ids = this.state.selectedRowKeys;
        axios.post(API.QSELECTTNEW_TASK_ASSIGN_CHECK_USER, {task_id:ids,user_id:this.state.assignCheck}).then((res)=>{
            res = res.data;
            if (res.code === 0) {
                message.success("分配成功！");
                this.setState({assignCheckVisible:false})
                this.getTaskList();
            }else{
                message.error(res.message);
                this.setState({assignCheckVisible:false})
            }
        },()=>{message.error("分配失败！")})
    }


    questionTypeChange = (value,list) => {
        let index = value.findIndex(d=>d=='选中多个')//增加选中多个的效果
        if(index!==-1){
            value.splice(index,1)
        }
        if(value.length<this.state.tag_type.length){//减少选中时
            if(value.length == list.length-1){//取消全部时
                let index = value.findIndex(d=>d=='-1')
                if(index==-1){
                    value = []
                }
            }
            let index = value.findIndex(d=>d=='-1')
            if(index!==-1){
                value.splice(index,1)
            }
        }else if(value.length==list.length-1){//选中了其余所有后自动选中全部
            value = list.map(d=>''+d.id)
        }
        if(value.findIndex(d=>d=='4')==-1){
            this.setState({skip_know: 0})
            this.setState({is_spread: '0'})
            let index = value.findIndex(d=>d=='5')
            if(index!==-1){
                value.splice(index,1)
            }
        }
        this.setState({tag_type: value});
        this.forceUpdate()
    }
    checkMultiple=(state,list)=>{
        if(!(list&&list.length)){return}
        let index = this.state.tag_type.findIndex(d=>d=='选中多个')//增加选中多个的效果
        if(index!==-1){
            this.state.tag_type.splice(index,1)
        }

        if(this.state.tag_type.some(d=>d=='5')){
            if(this.state.tag_type.length===list.length){return}
            if(!this.state.tag_type.some(d=>d=='4')){
                this.state.tag_type.push('4')
            }
        }
        if(this.state.tag_type.some(d=>d=='-1')){
            if(this.state.tag_type.length===list.length){return}
            let arr = list.map(d=>''+d.id)
            this.state.tag_type = arr
        }

        else if(this.state.tag_type.length>1){
            this.state.tag_type.unshift('选中多个')
        }
    }
    ///分类多选功能
    questionTypeChangeClassify = (value,list) => {
        let index = value.findIndex(d=>d=='选中多个')//增加选中多个的效果
        if(index!==-1){
            value.splice(index,1)
        }
        if(value.length<this.state.node_knowledge_type.length){//减少选中时
            if(value.length == list.length-1){//取消全部时
                let index = value.findIndex(d=>d=='-10')
                if(index==-1){
                    value = []
                }
            }
            let index = value.findIndex(d=>d=='-10')
            if(index!==-1){
                value.splice(index,1)
            }
        }else if(value.length==list.length-1){//选中了其余所有后自动选中全部
            value = list.map(d=>''+d.id)
        }
        this.setState({node_knowledge_type: value});
        this.forceUpdate()
    }
    checkMultipleClassify=(state,list)=>{
        if(!(list&&list.length)){return}
        let index = this.state.node_knowledge_type.findIndex(d=>d=='选中多个')//增加选中多个的效果
        if(index!==-1){
            this.state.node_knowledge_type.splice(index,1)
        }

        if(this.state.node_knowledge_type.some(d=>d=='-10')){
            if(this.state.node_knowledge_type.length===list.length){return}
            let arr = list.map(d=>''+d.id)
            this.state.node_knowledge_type = arr
        }
        else if(this.state.node_knowledge_type.length>1){
            this.state.node_knowledge_type.unshift('选中多个')
        }
    }
    ///分类多选功能


    render() {

        let filterList  = [...this.props.filterList]
        if(filterList&&filterList){filterList.unshift({id:'-10',name:'全部'})}

        const { taskList,total } = this.props;
        const role_qselect = this.props.user.role_qselect
        taskList.forEach(d=>d.key=d.task_id)
        const {selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys,dsd) => {//表格行的选则框
                this.setState({ selectedRowKeys:selectedRowKeys });
            },
        };

        const columns = []
        role_qselect&&role_qselect.columns[this.props.stage-1]&&role_qselect.columns[this.props.stage-1].forEach((d,k)=>{
            if(d){
                columns.push(columnsOrgign[k])
            }
        })


        columns.push({
            title: '泛化',
            dataIndex: 'is_spread',
            width: 50,
            render: (text, record, index) => {
                return record.is_spread==='1'?'是':'否'
            }
        },{
            title: '操作',
            width: 100,
            render: (text, record, index) => {

                return <div>
                    {
                        this.props.stage==='1'&&//进行中
                        (role_qselect.showall||
                            (role_qselect&&role_qselect.select===1&&this.props.user.id===record.select_user)
                        ) &&
                        <a onClick={()=>{this.toSetTag(record)}}>
                            打标签
                        </a>
                    }
                    {
                        this.props.stage==='1'&&//进行中
                        (role_qselect.showall||
                            (role_qselect&&role_qselect.check===1&&this.props.user.id===record.check_user)
                        ) &&
                        <a style={{marginLeft:10}} onClick={()=>{this.toCheckTag(record)}}>
                            审核
                        </a>
                    }
                    {
                        this.props.stage==='2'&&//已关闭
                        (role_qselect.showall||
                            (role_qselect&&role_qselect.isSpread===1)
                        ) &&
                        <Popconfirm title="确认修改吗？" onConfirm={()=>{this.changeSpread(record)}} okText="确认" cancelText="取消">
                                <a style={{marginLeft:10}} >
                                    {record.is_spread==='1'?'不泛化':'泛化'}
                                </a>
                        </Popconfirm>

                    }
                    {
                        this.props.stage!=='1'&&//非进行中
                        (role_qselect.showall) &&
                        <a style={{marginLeft:10}} onClick={()=>{this.toLookTag(record)}}>
                            查看
                        </a>
                    }

                </div>

            }
        })


        return (
            <div>
                <Breadcrumb>
                    <Breadcrumb.Item style={{fontSize:20}}>
                        <span>题目管理</span>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item style={{fontSize:20}}>
                        <span>打标签</span>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <Row style={{marginTop:15}}>
                    <Col span={24}>

                        <Row style={{marginBottom:5}}>
                            {/*录解析*/}
                            <div style={{fontSize: 14,marginLeft:'40px',display:'inline-block'}}>
                                <label style={{width:'80px',display:'inline-block'}} htmlFor="search_text_explain">任务ID</label>
                                <Input
                                    placeholder="输入id"
                                    style={{ width: 200,marginRight:10}}
                                    onChange={(e)=>this.setState({searchId:e.target.value})}
                                    value={this.state.searchId}
                                />
                            </div>
                            <div style={{fontSize: 14,marginLeft:'40px',display:'inline-block'}}>
                                <label style={{width:'80px',display:'inline-block'}} htmlFor="search_text_explain">任务名</label>
                                <Input
                                    placeholder="输入任务名"
                                    style={{ width: 400,marginRight:10}}
                                    onChange={(e)=>this.setState({searchName:e.target.value})}
                                    value={this.state.searchName}
                                />
                            </div>
                        </Row>
                        <Row style={{marginBottom:5}}>
                            {/*录解析*/}
                            {
                                role_qselect&&role_qselect.showall&&
                                <div style={{display:'inline-block'}}>
                                    <div style={{fontSize: 14,marginLeft:'40px',display:'inline-block'}}>
                                        <label style={{width:'80px',display:'inline-block'}} htmlFor="search_text_explain">打标签人</label>
                                        <Select
                                            value={this.state.selectTagUser}
                                            style={{ width: 120 }}
                                            onChange={(val)=>{this.setState({selectTagUser:val})}}
                                            showSearch
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >

                                            <Option key={-1} value={'-1'}>所有</Option>
                                            {
                                                this.props.selectList&&this.props.selectList.map(item =>
                                                    <Option key={item.id} value={item.id.toString()}>{item.username}</Option>)
                                            }
                                        </Select>
                                    </div>
                                    <div style={{fontSize: 14,marginLeft:'40px',display:'inline-block'}}>
                                        <label style={{width:'80px',display:'inline-block'}} htmlFor="search_text_explain">审核人</label>
                                        <Select
                                            value={this.state.checkTagUser}
                                            style={{ width: 120 }}
                                            onChange={(val)=>{this.setState({checkTagUser:val})}}
                                            showSearch
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            <Option key={-1} value={'-1'}>所有</Option>
                                            {
                                                this.props.checkList&&this.props.checkList.map(item =>
                                                    <Option key={item.id} value={item.id.toString()}>{item.username}</Option>)
                                            }
                                        </Select>
                                    </div>

                                    <div style={{fontSize: 14,marginLeft:'40px',display:'inline-block'}} className={'creat_task_multipe_select'}>
                                        <label style={{width:'80px',display:'inline-block'}} htmlFor="search_text_explain">标签种类</label>
                                        {this.checkMultiple(this.state,this.state.tagTypeList)}
                                        <Select value={ this.state.tag_type }
                                                style={{width:100, marginRight:20,verticalAlign:'top'}}
                                                mode={"multiple"}
                                                onBlur={()=>{
                                                    $('.creat_task_multipe_select .ant-select-selection--multiple').css('height','auto')
                                                    setTimeout(()=>{
                                                        $('.creat_task_multipe_select .ant-select-selection--multiple').css('height','28px')
                                                    },0)}}
                                                onChange = { (value, option) => this.questionTypeChange(value, this.state.tagTypeList) }>
                                            {
                                                this.state.tagTypeList&&this.state.tagTypeList.map((v,k) =>
                                                    <Option key = {k} value= {''+v.id}>{v.name}</Option>
                                                )
                                            }
                                        </Select>
                                    </div>
                                    <div style={{fontSize: 14,marginLeft:'40px',display:'inline-block'}} className={'creat_task_multipe_select creat_task_multipe_select_classify'}>
                                        <label style={{width:'80px',display:'inline-block'}} htmlFor="search_text_explain">类型</label>

                                        {
                                            (this.checkMultipleClassify(this.state,filterList)||1)&&
                                            <Select
                                                value={ this.state.node_knowledge_type }
                                                style={{width:120, marginRight:20,verticalAlign:'top'}}
                                                // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                // showSearch
                                                mode={"multiple"}
                                                onBlur={()=>{
                                                    $('.creat_task_multipe_select_classify .ant-select-selection--multiple').css('height','auto')
                                                    setTimeout(()=>{
                                                        $('.creat_task_multipe_select_classify .ant-select-selection--multiple').css('height','28px')
                                                    },0)}}
                                                onChange={(value, option) => this.questionTypeChangeClassify(value, filterList)}
                                            >
                                                {
                                                    filterList&&filterList.map(item =>
                                                        <Option key={item.id} value={item.id.toString()}>{item.name}</Option>)
                                                }
                                            </Select>
                                        }
                                    </div>
                                </div>
                            }



                            <Button style={{fontSize: 12,marginLeft:'20px'}} type="primary" onClick={this.onAdvanceSearch}>搜索</Button>
                        </Row>


                    </Col>
                </Row>

                <Row style={{marginTop:10,maxWidth:1280}}>
                    <Col span={24}>
                        <div style={{fontSize:12}}>
                            <Menu
                                onClick={(e)=>{this.props.setStage(e.key)}}
                                selectedKeys={[this.props.stage]}
                                mode="horizontal"
                                style={{marginBottom:5,backgroundColor:'#f7f7f7',padding:'0 15px',borderRadius:6}}
                            >
                                {
                                    role_qselect&&role_qselect.columns[0].some(d=>d>0)&&
                                    <Menu.Item key="1">进行中</Menu.Item>
                                }
                                {
                                    role_qselect&&role_qselect.columns[1].some(d=>d>0)&&
                                    <Menu.Item key="2">已关闭</Menu.Item>
                                }
                                {
                                    role_qselect&&role_qselect.columns[2].some(d=>d>0)&&
                                    <Menu.Item key="3">入库中</Menu.Item>
                                }
                                {
                                    role_qselect&&role_qselect.columns[3].some(d=>d>0)&&
                                    <Menu.Item key="4">入库失败</Menu.Item>
                                }
                                {
                                    role_qselect&&role_qselect.columns[4].some(d=>d>0)&&
                                    <Menu.Item key="5">已入库</Menu.Item>
                                }
                                {
                                    role_qselect&&role_qselect.columns[5].some(d=>d>0)&&
                                    <Menu.Item key="6">已上线</Menu.Item>
                                }

                            </Menu>
                        </div>
                    </Col>

                </Row>
                <div style={{ marginBottom: 10 }}>
                    {
                        (this.props.stage==='1')&&
                        role_qselect&&role_qselect.add===1 &&
                        <Button style={{fontSize: 12,marginRight:10}} type="primary" onClick={()=>{this.setState({createTaskVisible:true,taskId:''}) }}>创建任务</Button>

                    }
                    {(this.state.createTaskVisible) && <CreateTask onCancel={()=>{this.setState({createTaskVisible:false})}} visible={this.state.createTaskVisible} taskId={this.state.taskId} refresh={()=>{this.onRefreshList(1)}}/>}

                    {
                        (this.props.stage==='1')&&
                        role_qselect&&role_qselect.del===1 &&
                        <Button type="primary" style={{ marginRight: 10 }} disabled={!rowSelection.selectedRowKeys.length} onClick={()=>{this.delTask() }}>删除任务</Button>
                    }
                    {
                        (this.props.stage==='1')&&
                        role_qselect&&role_qselect.assignSelect===1 &&
                        <Button type="primary" style={{ marginRight: 10 }} disabled={!rowSelection.selectedRowKeys.length} onClick={()=>this.setState({assignSelectVisible:true})}>分配打标签人</Button>
                    }

                    {
                        <Modal title="分配打标签人" visible={this.state.assignSelectVisible} onOk={this.onAssignSelect} onCancel={()=>this.setState({assignSelectVisible:false})}>
                            <Select
                                placeholder="打标签"
                                style={{width:'61.4%'}}
                                onChange={(val)=>{this.setState({assignSelect:val})}}
                                value={this.state.assignSelect}

                                showSearch
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            >
                                {
                                    this.props.selectList&&this.props.selectList.map(item =>
                                        <Option key={item.id} value={item.id.toString()}>{item.username}</Option>)
                                }
                            </Select>
                        </Modal>
                    }
                    {
                        (this.props.stage==='1')&&
                        role_qselect&&role_qselect.assignCheck===1 &&
                        <Button type="primary" style={{ marginRight: 10 }} disabled={!rowSelection.selectedRowKeys.length} onClick={()=>this.setState({assignCheckVisible:true})}>分配审核人</Button>
                    }

                    {
                        <Modal title="分配审核人" visible={this.state.assignCheckVisible} onOk={this.onAssignCheck} onCancel={()=>this.setState({assignCheckVisible:false})}>
                            <Select
                                placeholder="审核"
                                style={{width:'61.4%'}}
                                onChange={(val)=>{this.setState({assignCheck:val})}}
                                value={this.state.assignCheck}

                                showSearch
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            >
                                {
                                    this.props.checkList&&this.props.checkList.map(item =>
                                        <Option key={item.id} value={item.id.toString()}>{item.username}</Option>)
                                }
                            </Select>
                        </Modal>
                    }
                    {
                        (this.props.stage==='1')&&
                        role_qselect&&role_qselect.end===1 &&
                        <Button type="primary" style={{ marginRight: 10 }} disabled={!rowSelection.selectedRowKeys.length}onClick={this.getCloseTagTaskMsg}>关闭任务</Button>
                    }
                    {
                        (this.props.stage==='2'||this.props.stage==='4')&&
                        role_qselect&&role_qselect.onlineBase===1 &&
                        <Button type="primary" style={{ marginRight: 10 }} disabled={!rowSelection.selectedRowKeys.length} onClick={()=>{this.onlineTask() }}>入库</Button>
                    }

                    {
                        (this.props.stage==='5'||this.props.stage==='6')&&
                        role_qselect&&role_qselect.onlineTest===1 &&
                        <Button type="primary" style={{ marginRight: 10 }} disabled={!rowSelection.selectedRowKeys.length} onClick={()=>{this.onTestTask()}}>上测试</Button>
                    }

                    {
                        (this.props.stage==='5')&&
                        role_qselect&&role_qselect.onlineProp===1 &&
                        <Button type="primary" style={{ marginRight: 10 }} disabled={!rowSelection.selectedRowKeys.length} onClick={()=>{this.onlineSusuanTask() }}>上线</Button>
                    }
                    {
                        role_qselect&&role_qselect.download===1 &&
                        <Button type="primary" style={{ marginRight: 10 }} disabled={!rowSelection.selectedRowKeys.length} onClick={()=>{this.downloadList()}}>打标签统计表</Button>
                    }

                </div>
                <Table
                    rowSelection={rowSelection}
                    columns={columns}
                    dataSource={taskList}
                    pagination={{current:this.state.page,pageSize:+this.state.pagesize,total:total,onChange:(val) => {this.setState({page:val});setTimeout(()=>{this.getTaskList()},0)} }}
                    scroll={{ x: 1300 }} />
            </div>
        )
    }
}

const mapStateTopProps = state => {
    return {
        taskList: state.questionManage.setTag.taskList,
        total:state.questionManage.setTag.total,
        stage: state.questionManage.setTag.stage,
        checkList: state.questionManage.setTag.checkList,
        selectList: state.questionManage.setTag.selectList,
        filterList: state.questionManage.setTag.filterList,
        user:state.user,

    }
}
const mapDispatchToProps = dispatch => {
    return {
        getTaskList: (data) => {
            dispatch(action.getTaskList(data));
        },
        getSelectList: (data) => {
            dispatch(action.getSelectList(data));
        },
        getCheckList: (data) => {
            dispatch(action.getCheckList(data));
        },
        getFilterList: (data) => {
            dispatch(action.getFilterList(data));
        },
        setStage: (data) => {
            dispatch(action.setStage(data));
        },
    }
};
export default connect(mapStateTopProps, mapDispatchToProps)(HitTag);


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/set_tag/tag_task_list/view.js